// extracted by mini-css-extract-plugin
export default {"content":"Editable_content__OzuU3","modal":"Editable_modal__Xs++h"};